export default "__VITE_ASSET__Bh6oGiZf__"